import React from "react";
import './AnnualReport.css'

import useMeta from '../../../../hooks/useMeta'

import { Link, useParams } from "react-router-dom";

import Navbar from "../../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../../CommonComponent/Footer/footer";

import { Annual_Report_Year_List } from "./Annual_Report_data";

const Year_Wise_Annual_Report = () => {

    const { Get_Current_Year } = useParams();

    const CurrentYear_Data = Annual_Report_Year_List[Get_Current_Year];

    const data = CurrentYear_Data?.data || null;

    const CurrenrtYear_pg_title = CurrentYear_Data?.PG_title || null;

    const Meta_title = CurrentYear_Data?.Meta_title || null;
    const OG_title = CurrentYear_Data?.OG_title || null;
    const Meta_Description = CurrentYear_Data?.Meta_Description || null;
    const OG_Description = CurrentYear_Data?.OG_Description || null;
    const Meta_OG_URl = CurrentYear_Data?.Meta_OG_URl || null;

    useMeta({
        title: Meta_title,
        description: Meta_Description,
        canonical: Meta_OG_URl,
        og: {
            locale: 'en_US',
            type: 'article',
            title: OG_title,
            description: OG_Description,
            url: Meta_OG_URl,
            site_name: 'Marvel Blinds',
        },
    });

    function CheckValue(index) {
        return (index % 2 !== 0) ? true : false
    }

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="AR_pg_container">
                {CurrenrtYear_pg_title && (<h1 className="AR_pg_title">{CurrenrtYear_pg_title}</h1>)}
                <table className="AR_pg_table">
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td className={CheckValue(index) === true ? (index !== data.length - 1 ? 'Border-none' : 'border-top-none') : 'even-row'}>
                                    <Link target="__blank " to={item.url || "#"}>
                                        {item.title}
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}


export default Year_Wise_Annual_Report;